var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7677cb146b0151bd4e0efecd5c6d49c4.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7accdf398aae1a8019101c029f866803.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f53a88c4ccbc640968b83c8ad51dae2a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    